module.exports = __webpack_public_path__ + "img/vertical_4_1_8023.deae63b8.png";